import { render, staticRenderFns } from "./AssignDriversModal.vue?vue&type=template&id=0d18111e&scoped=true&"
import script from "./AssignDriversModal.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./AssignDriversModal.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./AssignDriversModal.vue?vue&type=style&index=0&id=0d18111e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d18111e",
  null
  
)

export default component.exports